;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="18d9853e-1d7f-4146-9a60-b46d999eac99",e._sentryDebugIdIdentifier="sentry-dbid-18d9853e-1d7f-4146-9a60-b46d999eac99")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useContext, useState } from 'react';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import Multilanguage from '../Multilanguage/Multilanguage.js';
import BurgerHeader from './BurgerHeader.js';
import styles from './BurgerNavigation.module.scss.js';
import { convertPanelMap, ROOT_PATH } from './BurgerNavigationConverter.js';
import BurgerPanel from './BurgerPanel.js';

const MULTILANGUAGE_BAR_HEIGHT = 56;
const MIDDLE_BAR_HEIGHT = 60;
function BurgerNavigation({ handleCloseClick, open, }) {
    const { categories, translations, multilanguage } = useContext(AppContext);
    const [panelsMap, setPanelsMap] = useState(convertPanelMap(categories, translations.get('shop.header.categories.title.link')));
    if (!panelsMap.size) {
        return null;
    }
    const openPanels = Array.from(panelsMap.values()).filter((panel) => panel.show);
    const onClickNextPanel = (nextPanelPath) => {
        const nextPanel = panelsMap.get(nextPanelPath);
        if (nextPanel) {
            nextPanel.show = true;
        }
        setPanelsMap(new Map(panelsMap));
    };
    const onClickPrevPanel = (currentPanelPath) => {
        const currentPanel = panelsMap.get(currentPanelPath);
        if (currentPanel) {
            currentPanel.show = false;
        }
        setPanelsMap(new Map(panelsMap));
    };
    const currentPanel = openPanels.slice(-1)[0];
    const panelWrapperHeight = MIDDLE_BAR_HEIGHT + (multilanguage ? MULTILANGUAGE_BAR_HEIGHT : 0);
    const handleClose = () => {
        // reset the panels when close trigger
        openPanels.forEach((panel) => {
            const currentPanel = panelsMap.get(panel.currentPath);
            if (currentPanel) {
                currentPanel.show = panel.currentPath === ROOT_PATH;
            }
        });
        setPanelsMap(new Map(panelsMap));
        handleCloseClick();
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { "data-zta": "hamburger-navigation-wrapper", className: classNames(styles.mobileBurgerNavOverlay, {
                [styles.open]: open,
            }), onClick: handleClose }),
        React__default.createElement("nav", { "aria-expanded": open, className: classNames(styles.mobileBurgerNav, {
                [styles.open]: open,
            }), "data-zta": "hamburger-navigation" },
            React__default.createElement(BurgerHeader, { currentPanel: currentPanel, onClickPrevPanel: onClickPrevPanel, translations: translations, onCloseClick: handleClose, isOpen: open }),
            React__default.createElement("div", { className: styles.burgerPanelsWrapper, "data-zta": "burger-panels-wrapper", style: {
                    '--header-panel-wrapper-height': `calc(100% - ${panelWrapperHeight}px)`,
                    '--header-panel-wrapper-width': `${openPanels.length * 100}%`,
                    '--header-panel-wrapper-left': `${(openPanels.length - 1) * -100}%`,
                } },
                React__default.createElement(BurgerPanel, { onClickNextPanel: onClickNextPanel, openPanels: openPanels })),
            multilanguage && React__default.createElement(Multilanguage, null))));
}

export { MIDDLE_BAR_HEIGHT, MULTILANGUAGE_BAR_HEIGHT, BurgerNavigation as default };
//# sourceMappingURL=BurgerNavigation.js.map
